export const mockMovies = [
    {
        id: 1,
        title: "Stranger Things",
        name: "Stranger Things",
        backdrop_path: "https://wallpaperaccess.com/full/2703652.png",
        poster_path: "https://image.tmdb.org/t/p/original/x2LSRm21uTEx2Pq2SUTU7G36fVy.jpg",
        overview: "When a young boy vanishes, a small town uncovers a mystery involving secret experiments, terrifying supernatural forces and one strange little girl.",
    },
    {
        id: 2,
        title: "The Witcher",
        name: "The Witcher",
        backdrop_path: "https://images.alphacoders.com/105/1059530.jpg",
        poster_path: "https://image.tmdb.org/t/p/original/7vfqwhuYp6v6968S9pY2A6v8pY.jpg",
        overview: "Geralt of Rivia, a solitary monster hunter, struggles to find his place in a world where people often prove more wicked than beasts.",
    },
    {
        id: 3,
        title: "Money Heist",
        name: "Money Heist",
        backdrop_path: "https://images6.alphacoders.com/839/839082.jpg",
        poster_path: "https://image.tmdb.org/t/p/original/reEMJA1uzpG6Xp7TYvzs7hgA6p7.jpg",
        overview: "To pull off the greatest heist in history, a mysterious man called The Professor recruits a band of eight robbers who have a single characteristic: none of them has anything to lose.",
    },
    {
        id: 4,
        title: "Inception",
        backdrop_path: "https://images7.alphacoders.com/310/310927.jpg",
        overview: "A thief who steals corporate secrets through the use of dream-sharing technology is given the inverse task of planting an idea into the mind of a C.E.O.",
    },
    {
        id: 5,
        title: "Interstellar",
        backdrop_path: "https://images5.alphacoders.com/548/548301.jpg",
        overview: "A team of explorers travel through a wormhole in space in an attempt to ensure humanity's survival.",
    }
];

export const mockCategories = {
    trending: mockMovies.slice(0, 5),
    originals: mockMovies.slice(0, 3),
    action: mockMovies.slice(1, 4),
    comedy: mockMovies.slice(2, 5),
    horror: mockMovies.slice(0, 3),
    romance: mockMovies.slice(1, 4),
    documentary: mockMovies.slice(2, 5),
};
